import classnames from 'classnames';

import {TagRegularDiagonalIcon} from 'shells/icon/svg/tag-regular-diagonal-icon';

import {colors} from '../../colors/colors';
import {LoadingText} from '../../loading-placeholder/loading-text';
import {Body} from '../../typography/body';

import styles from './lead-value.module.css';

type LeadValueVariant = 'default' | 'mini';

interface Props {
    valueFormatted: string | null | undefined;
    variant?: LeadValueVariant;
}

export function LeadValue(props: Props) {
    const {variant = 'default'} = props;
    const isMini = variant === 'mini';

    return (
        <div
            className={classnames(styles['lead-value'], {
                [styles['lead-value--mini']]: isMini,
            })}
        >
            <TagRegularDiagonalIcon
                size={isMini ? 16 : 20}
                // @ts-expect-error
                color={colors.greenDk}
                wrapWithDiv={false}
            />
            {props.valueFormatted ? (
                <Body size={isMini ? 'normal' : 'xlarge'}>{props.valueFormatted}</Body>
            ) : (
                <LoadingText
                    color={colors.greyXlt}
                    height={isMini ? 14 : 18}
                    width={isMini ? 44 : 60}
                />
            )}
        </div>
    );
}
